import React from 'react';
import { Spinner, Button, Row, Col } from 'reactstrap';
import BulkCsvColumnMapperItem from './BulkCsvColumnMapperItem';

const BulkCsvColumnMapper = ({
  step,
  loading,
  onSubmit,
  tableData,
  appendableColumns,
  setAppendableColumns,
  onTableColumnUnSelect,
  onTableColumnSelect,
}) => {
  if (step === 1) {
    return (
      <div className="w-100 mt-3">
        <div className="d-flex align-items-center gap-2 mb-2" style={{ opacity: 0.5 }}>
          <div
            style={{
              width: '20px',
              height: '20px',
              backgroundColor: '#697277',
              color: 'white',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '14px',
              fontWeight: 500,
            }}
          >
            2
          </div>
          <div style={{ fontSize: '18px', fontWeight: 500, color: '#697277' }}>
            Map columns to fields
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-100 mt-3">
      <div className="d-flex align-items-center gap-2 mb-2">
        <div
          style={{
            width: '20px',
            height: '20px',
            backgroundColor: '#0d6efd',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '14px',
            fontWeight: 500,
          }}
        >
          2
        </div>
        <div style={{ fontSize: '18px', fontWeight: 500, color: '#333' }}>
          Map columns to fields
        </div>
      </div>

      <p className="text-muted mb-2" style={{ fontSize: '13px' }}>
        Map each column from your file to the corresponding field. Fields marked with * are required.
      </p>

      <Row className="d-none d-md-flex pt-2 px-3">
        {['FILE HEADER', 'SAMPLE DATA', 'MAP TO FIELD'].map((text, index) => (
          <Col key={index}>
            <div style={{ fontSize: '14px', fontWeight: 600, color: '#697277', textAlign: 'left' }}>
              {text}
            </div>
          </Col>
        ))}
      </Row>

      {tableData?.columns?.map((column, i) => {
        const allTableData = tableData?.data;
        let tableItem = { column: column?.Header, data: [] };

        if (column?.appendedValue) {
          tableItem.appendedValue = column?.appendedValue;
        }

        for (let j = 0; j < allTableData?.length; j++) {
          if (allTableData[j][`${column?.Header}`]) {
            tableItem = {
              ...tableItem,
              data: [...tableItem.data, allTableData[j][`${column?.Header}`]],
            };
            if (tableItem.data.length === 3) break;
          }
        }

        return (
          <BulkCsvColumnMapperItem
            key={i}
            table={tableItem}
            appendableColumns={appendableColumns}
            onTableColumnUnSelect={onTableColumnUnSelect}
            onTableColumnSelect={onTableColumnSelect}
          />
        );
      })}

      <div className="py-4 d-flex justify-content-center align-items-center">
        <Button color="primary" disabled={loading} onClick={onSubmit}>
          <span style={{ fontSize: '15px', fontWeight: 500 }}>
            Confirm & Send Bulk Invites
          </span>
          {loading && <Spinner size="sm" color="light" className="ms-2" />}
        </Button>
      </div>
    </div>
  );
};

export default BulkCsvColumnMapper;
